/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ICON_LOGS, ICON_MONITOR_HEART } from '@squiz/sds';
import { DashboardCardProps } from 'apps/console-core/src/Components/DashboardCard/DashboardCard.props';
import { screenPaths } from '../../Constants/ScreenPaths.constants';
import { MONITORING_STRINGS } from '../../Constants/Strings.constants';

export const EXPERIENCE_MONITORING_DASHBOARD_CARD: DashboardCardProps = {
  description: MONITORING_STRINGS.experienceMonitoringDesc,
  icon: ICON_MONITOR_HEART,
  link: screenPaths.experienceMonitoring,
  title: MONITORING_STRINGS.experienceMonitoring,
};

export const LOGS_DASHBOARD_CARD: DashboardCardProps = {
  description: MONITORING_STRINGS.logsDesc,
  icon: ICON_LOGS,
  link: screenPaths.logs,
  title: MONITORING_STRINGS.logs,
};

export const MONITORING_DASHBOARD_CARDS = [LOGS_DASHBOARD_CARD, EXPERIENCE_MONITORING_DASHBOARD_CARD];
